export var PricePart;
(function (PricePart) {
    PricePart["CURRENCY"] = "currency";
    PricePart["GROUP"] = "group";
    PricePart["DECIMAL"] = "decimal";
})(PricePart || (PricePart = {}));
//# sourceMappingURL=PricePart.js.map